import React, {useEffect, useState} from 'react';
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {baseUrl_back} from "../../api/BaseUrl";
import BreadPath from "../BreadPath/BreadPath";
import {
    Button,
    Container,
    Modal,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow, TextField,
    Typography
} from "@mui/material";
import {MDBContainer} from "mdb-react-ui-kit";
import BackServer from "../../api/BackServer";
import OneProductGlass from "../OneProductShort/OneProductGlass";
import Box from "@mui/material/Box";
import ModalStocks from "../modalStocks/modalStocks";




const Stocks = () => {


    const [stks, setstks] = useState([])
    const [art, setart] = useState("-")

    const getStocks = async () => {
        const response = await BackServer.getStockFromMyBD(art)
        // alert(JSON.stringify(response.dta));
        console.log(response.dta)
        setstks(response.dta)
    }

    function handleChangex(e) {
        setart(e.target.value);
    }
    function refr(e) {
        getStocks()
    }
    useEffect(() => {
        getStocks()
    }, [])
    return (
        <>

            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 100 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">
                                <TextField
                                    sx={{ mt: 2 }}
                                    id="outlined-disabled"
                                    label="Количество"
                                    defaultValue={art}
                                    value={art}
                                    onChange={handleChangex}
                                />
                            </TableCell>
                            <TableCell align="center">
                                <Button onClick={refr} variant="contained">Find</Button>
                            </TableCell>
                            {/*<TableCell align="right">Fat&nbsp;(g)</TableCell>*/}
                            {/*<TableCell align="right">Carbs&nbsp;(g)</TableCell>*/}
                            {/*<TableCell align="right">Protein&nbsp;(g)</TableCell>*/}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {stks.map((row) => (
                            <TableRow
                                key={row.name}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell align="center" component="th" scope="row">
                                    {row.key}
                                </TableCell>
                                <TableCell align="center"><ModalStocks nme={row.key} art={row.value}></ModalStocks></TableCell>
                                {/*<TableCell align="right">{"--"}</TableCell>*/}
                                {/*<TableCell align="right">{"--"}</TableCell>*/}
                                {/*<TableCell align="right">{"----"}</TableCell>*/}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

        </>
    );
};

export default Stocks;